import { BrowserRouter, Routes, Route } from "react-router-dom";

// ✅ UPDATED IMPORTS (exact paths)
import Login from "./pages/auth/login/LoginPage";
import Register from "./pages/auth/register/RegisterPage";
import Dashboard from "./pages/dashboard/Dashboard";
import MyChat from "./pages/dashboard/MyChat";


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/mychat" element={<MyChat />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
